import {
  CloudSun,
  Compass,
  Leaf,
  Sailboat,
  Sparkles,
  Star,
  type LucideIcon
} from "lucide-react";

export type ProfileAvatarTone =
  | "berry"
  | "coral"
  | "leaf"
  | "sky"
  | "sun"
  | "teal";

export interface ProfileAvatarOption {
  readonly id: string;
  readonly label: string;
  readonly icon: LucideIcon;
  readonly tone: ProfileAvatarTone;
}

export const PROFILE_AVATAR_OPTIONS = [
  { id: "captain-blue", label: "蓝帆", icon: Sailboat, tone: "sky" },
  { id: "captain-sun", label: "暖阳", icon: CloudSun, tone: "sun" },
  { id: "captain-leaf", label: "新芽", icon: Leaf, tone: "leaf" },
  { id: "captain-star", label: "星光", icon: Star, tone: "berry" },
  { id: "captain-compass", label: "远航", icon: Compass, tone: "teal" },
  { id: "captain-spark", label: "闪闪", icon: Sparkles, tone: "coral" }
] as const satisfies readonly ProfileAvatarOption[];

export type PresetAvatarId = (typeof PROFILE_AVATAR_OPTIONS)[number]["id"];

export function getProfileAvatarOption(
  avatarId: string
): ProfileAvatarOption | undefined {
  return PROFILE_AVATAR_OPTIONS.find((option) => option.id === avatarId);
}
